import {ADD_MESSAGE, ADD_FAKE_MESSAGE, SEND_MESSAGE} from '../actions';
import MessageFactory from '../services/messageFactory';
import _ from 'lodash';

function activityExist({messages, activityId, clientReferenceId}) {
  return _.findIndex(messages, {activityId}) !== -1 ||
    _.findIndex(messages, {activityId: clientReferenceId}) !== -1;
}

function updateMessage(messages, clientReferenceId, updateInfo) {
  return messages.map(message =>
    message.activityId === clientReferenceId ?
      Object.assign({}, message, updateInfo) :
      message
  );
}

function onSendFulfilled({messages, clientReferenceId, newId, dateTime}) {
  return updateMessage(messages, clientReferenceId, {activityId: newId, dateTime});
}

function onSendRejected({messages, clientReferenceId}) {
  return updateMessage(messages, clientReferenceId, {error: true});
}

export default function conversationHistory(state = [], action) {
  switch (action.type) {
    case `${SEND_MESSAGE}_PENDING`:
    case `${ADD_MESSAGE}`:
    case `${ADD_FAKE_MESSAGE}`:
      if (!activityExist({
        messages: state,
        activityId: action.meta.activity.activityId,
        clientReferenceId: action.meta.clientReferenceId
      })) {
        return state.concat(new MessageFactory({
          content: action.meta.activity.info.activityInfo.content[0].message,
          dateTime: action.meta.activity.dateTime,
          direction: action.meta.activity.direction,
          activityId: action.meta.activity.activityId,
          error: false
        }));
      }
      return action.type === `${SEND_MESSAGE}_PENDING` ? updateMessage(state, action.meta.clientReferenceId, {error: false}) : state;
    case `${SEND_MESSAGE}_FULFILLED`:
      return onSendFulfilled({
        messages: state,
        clientReferenceId: action.meta.clientReferenceId,
        newId: action.payload.activityId,
        dateTime: action.payload.dateTime
      });
    case `${SEND_MESSAGE}_REJECTED`:
      return onSendRejected({
        messages: state,
        clientReferenceId: action.meta.clientReferenceId
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./chat-app/reducers/conversationHistory.js